import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type Keys =
	| 'modalHeading'
	| 'attachmentValidationWarning'
	| 'modalSubmit'
	| 'modalClose'
	| 'commentLabel'
	| 'attachmentLabel'
	| 'issueUpdated'
	| 'issueAttached'
	| 'errorTitle'
	| 'errorDesc'
	| 'issueUpdatedIssueTermRefresh'
	| 'issueUpdatedIssueTerminologyRefreshM4';
type Messages = Record<Keys, MessageDescriptor>;
const messages: Messages = defineMessages({
	modalHeading: {
		id: 'issue-operations-attach-file-dialog.modal-heading',
		defaultMessage: 'Attach files: {issueKey}',
		description: 'Heading for attach files dialog',
	},
	attachmentValidationWarning: {
		id: 'issue-operations-attach-file-dialog.attachment-validation-warning',
		defaultMessage: 'File must be attached',
		description: 'Text in attach file dialog which alerts user to attach a file',
	},
	modalSubmit: {
		id: 'issue-operations-attach-file-dialog.modal-submit',
		defaultMessage: 'Attach',
		description: 'Submit dialog form to attach files',
	},
	modalClose: {
		id: 'issue-operations-attach-file-dialog.modal-close',
		defaultMessage: 'Close',
		description: 'Close attach file modal',
	},
	commentLabel: {
		id: 'issue-operations-attach-file-dialog.comment-label',
		defaultMessage: 'Comment',
		description: 'Label for comment field in attach file form',
	},
	attachmentLabel: {
		id: 'issue-operations-attach-file-dialog.attachment-label',
		defaultMessage: 'Attachment',
		description: 'Label for attachment field in attach file form',
	},
	issueUpdated: {
		id: 'issue-operations-attach-file-dialog.issue-updated',
		defaultMessage: 'Issue updated',
		description: 'Text in notification flag to alert user an issue has been updated.',
	},
	issueAttached: {
		id: 'issue-operations-attach-file-dialog.issue-attached',
		defaultMessage: 'Your file(s) have been attached to {issueKey}.',
		description:
			'Text in notification flag to alert user that they have attached files to an issue',
	},
	errorTitle: {
		id: 'issue-operations-attach-file-dialog.error-title',
		defaultMessage: 'Error',
		description: 'Text in notification flag to alert user that their issue operation failed',
	},
	errorDesc: {
		id: 'issue-operations-attach-file-dialog.error-desc',
		defaultMessage: 'Your file(s) could not be attached to {issueKey}.',
		description: 'Text in notification flag to alert user that their issue operation failed',
	},
	issueUpdatedIssueTermRefresh: {
		id: 'issue-operations-attach-file-dialog.issue-updated-issue-term-refresh',
		defaultMessage: 'Work item updated',
		description: 'Text in notification flag to alert user an issue has been updated.',
	},
	issueUpdatedIssueTerminologyRefreshM4: {
		id: 'issue-operations-attach-file-dialog.issue-updated-issue-term-refresh-m4',
		defaultMessage: 'Updated {workType} {issueKey}',
		description:
			'Text in notification flag to alert user an issue has been updated. Please translate as “work type {workType}”',
	},
});
export default messages;
